import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { CommonService } from "../../../_common/_service/user.service";
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';
import { BeforePaymentConfirmDialogComponent } from '../../popup/beforepayment-confirm-dialog/beforepayment-confirm-dialog.component';
import { ConfirmbanktransferDialogComponent } from '../../popup/confirm-banktransfer-dialog/confirm-banktransfer-dialog.component';


@Component({
  selector: 'app-korapaybanktransfernigeria',
  templateUrl: './korapaybanktransfernigeria.component.html',
  styleUrls: ['./korapaybanktransfernigeria.component.scss']
})

export class KorapaybanktransfernigeriaComponent implements OnInit {
  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  FlatChargesByCountry: any;
  recentReceiver: any;
  //show = 2;
  KorapaybanktransfernigeriaForm: FormGroup;
  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  //countryIsdcode: any;
  OperatorName: any;

  BeneficiaryInfoList: any;
  FullBeneficiaryInfo: any;
  AccountCode: any;
  payoutCurrency: any;

  public BeneficiaryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();


  beneficiary_country: any;
  beneficiary_phone: any;
  ActualAmount: any;
  editId: any;
  loadingspinner: boolean = false;
  beneficiary_account_no: any;


  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService,
    private _service: CommonService) {

    //this.countryIsdcode = localStorage.getItem('countryIsdcode');
    //AccountCode == channel selected code
    //channel == channel selected name

    this.KorapaybanktransfernigeriaForm = this.fb.group({
      AccountCode: ["KNT"],
      PaymentModeCode: ["RRP"],
      Amount: [null, [Validators.required]],
      Id: [null, [Validators.required]],
      Comment: [null],
      DeviceType: "web",

    })

  }


  ngOnInit(): void {
    this.token = this.tokenStorageService.getToken();
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();

      this.getBeneficiaryInfo("KNT");
      // listen for search field value changes
      this.BeneficiaryFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterBeneficiary();
        });


    }
    else {
      this._service.callMethodOfSecondComponent();
    }

    this.f.Amount.valueChanges.subscribe(val => {
      if (val == "") {
        this.commissionFee = 0;
        this.commissionTotal = 0;
      }

      if (val && val.length > 0) {
        if (this.f.PaymentModeCode.value && this.AccountCode) {
          debugger
          this.getServiceCommissionList(this.f.Amount.value, this.f.PaymentModeCode.value, this.AccountCode);
        }
        else {
          this.toastr.error("Selected Proper Option", 'Error');
        }
      }
    });
  }


  Back() {
    this.router.navigate(['/Go-on']);
  }

  get f() { return this.KorapaybanktransfernigeriaForm.controls; }

  //GetCurrentchannelVal(code: any, name: any) {

  //  this.f.Comment.setValue(null);
  //  //this.f.MobileMoneySource.setValue(null);
  //  this.f.Amount.setValue(null);
  //  // this.f.BeneficiaryName.setValue(null);
  //  this.commissionFee = 0;
  //  this.commissionTotal = 0;
  //  this.OperatorName = name;
  //  this.submitted = false;

  //  this.authService.getchannelList(code, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
  //    ;
  //    if (response.apiStatus == true) {
  //      ;
  //      this.channelList = response.apiData;

  //    }
  //    else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
  //      this.toastr.warning(response.apiMessage, 'Warning');
  //      this._service.callMethodOfSecondComponent();
  //    }
  //    else {
  //      this.toastr.error(response.apiMessage, 'Error');
  //    }

  //  }, (err: any) => {
  //    if (err.error instanceof Error) {
  //      this.toastr.error(err.error, 'Error');
  //    } else {

  //      this.toastr.error(err.error, 'Error');
  //    }
  //  }
  //  );


  //  this.viewTransactions(code);
  //}


  openAddBeneficiaryDetails() {
    this.router.navigate(['/KorapayBankTransferNigeriaBeneficiary'], { queryParams: { serviceCode: this.serviceCode }, skipLocationChange: true });
  }

  //openPasswordDialog(post: any) {
  //  
  //  this.submitted = true;
  //  if (this.KorapaybanktransfernigeriaForm.valid) {
  //    const dialogRef = this.dialog.open(ConfirmPasswordDialogComponent, {
  //      width: '450px',
  //      data: null
  //    });

  //    dialogRef.afterClosed().subscribe(result => {
  //      if (result !== undefined && result !== null && result) {
  //        post.Password = result;
  //        this.payMobMon(post);
  //      }
  //    });

  //  }
  //}
  string1: any;
  paymobileMoneyForm(post: any) {
    //
    this.submitted = true;
    if (this.KorapaybanktransfernigeriaForm.valid) {
      this.loadingspinner = true;
      var PayServicsReq = null;
      var AddServicsReq = null;

      //pop up 
      AddServicsReq = {
        Amount: parseFloat(post.Amount), AccountCode: post.PaymentModeCode
      }
      //form 
      PayServicsReq = {
        Amount: parseFloat(post.Amount), MobileMoneySource: this.AccountCode,
        BeneficiaryName: null, Comment: post.Comment, AccountCode: post.AccountCode

      }

      debugger
      var post1 = {
        //form
        PayServicsReq: JSON.stringify(PayServicsReq),
        //popup
        AddServicsReq: JSON.stringify(AddServicsReq),
        ServiceCode: this.serviceCode,
        PaymentModeCode: post.PaymentModeCode,
        DeviceType: "web"

      }

      // Convert String obect to JSON
      this.stringJson = JSON.stringify(post1);
      console.log("String json object :", this.stringJson);

      //  // ConvertjSON to an object
      //  this.stringObject = JSON.parse(this.stringJson);
      //  ////////console.log("JSON object -", this.stringObject);
      debugger;
      this.authService.paytransfertoBank(this.stringJson, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
        debugger;
        this.loadingspinner = false;
        debugger;
        //console.log("data succ response -", response);

        if (response.apiStatus == true && response.apiData.transactionStatus == 2) {
          this.data = response.apiData;
          ////////console.log("data succ response -", this.data);

          if (response.apiMessage == "SUCCESSFUL") {
            this.KorapaybanktransfernigeriaForm.reset();
            this.submitted = false;
            this.commissionFee = 0;
            this.commissionTotal = 0;
            this.ActualAmount = 0;
            this.openPaymentConfirmDialog(this.data);
          }
          
          else {
            this.toastr.error(response.apiMessage, 'Transaction Status');
          }

          this.tokenService.updateMessagetoken('token'); //after payment succeful done then update userinfo& bal          
        }
        else if (response.apiStatus == true && response.apiData.transactionStatus == 4) {
          this.toastr.info(response.apiMessage, 'Transaction Info');
          this.KorapaybanktransfernigeriaForm.reset();
          this.submitted = false;
          this.commissionFee = 0;
          this.commissionTotal = 0;
          this.ActualAmount = 0;

          this.tokenService.updateMessagetoken('token'); //after payment succeful done then update userinfo& bal          

        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }


  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {
    ;
    //this.submitted = true;
    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, this.currentUser.serviceid).subscribe((response:
      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {
      if (response.apiStatus == true) {

        this.commissionList = response.apiData;
        this.amt = Amountrequested;
        this.commissionFee = this.commissionList.totalCommission;
        this.commissionTotal = this.commissionList.totalAmount;
        this.ActualAmount = this.commissionList.actualAmount;
        this.payoutCurrency = response.apiData.payoutCurrency;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }







  openPaymentConfirmDialog(data: any) {
    const dialogRef = this.dialog.open(PaymentConfirmDialogComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      window.location.reload();
    });

  }



  viewTransactions(val: any) {

    this.authService.getUserOrdersdetails1(val, this.currentUser.serviceid).subscribe(response => {
      ;
      if (response.apiStatus == true) {
        this.userorderdetailList = response.apiData;
      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }


  openDialog(post: any) {
    debugger;
    this.submitted = true;
    if (this.KorapaybanktransfernigeriaForm.valid) {
      post.serviceName = 'Nigeria-Bank Transfer';
      post.commissionFee = this.commissionFee;
      post.OperatorName = this.OperatorName;
      post.beneficiary_country = this.beneficiary_country;
      post.beneficiary_phone = this.beneficiary_phone;
      post.beneficiary_account_no = this.beneficiary_account_no;

      //      post.serviceName = 'Korapay Nigeria Bank Transfer';
      //post.commissionFee = this.commissionFee;
      //post.OperatorName = this.bankName;
      //post.beneficiary_country = 'Nigeria';
      //post.beneficiary_account_no = post.account_number;
      const dialogRef = this.dialog.open(BeforePaymentConfirmDialogComponent, {
        width: '450px',
        disableClose: true,
        hasBackdrop: true, // or false, depending on what you want
        autoFocus: false,
        maxHeight: '90vh', //you can adjust the value as per your view
        data: post
      });

      dialogRef.afterClosed().subscribe(result => {
        ;
        if (result !== undefined && result !== null && result) {

          this.paymobileMoneyForm(post);
        }
      });

    }
  }


  getBeneficiaryInfo(codeval: any) {
    debugger;
    this.f.Id.setValue(null);
    this.f.Amount.setValue(null);
    this.f.Comment.setValue(null);
    this.commissionFee = 0;
    this.commissionTotal = 0;
    this.ActualAmount = 0;
    this.amt = 0;

    this.authService.GetbanktransferBeneficiaryDetails(codeval).subscribe(response => {
      debugger
      this.BeneficiaryInfoList = response;
      console.log(response);
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );
    //this.viewTransactions(codeval);
  }

  GetBeneficiaryInfobyId(Id: any, value: any, beneficiary_bank_name: any, beneficiary_country: any, beneficiary_phone: any, beneficiary_account_no: any) {
    debugger;
    this.AccountCode = value;
    this.OperatorName = beneficiary_bank_name;
    this.beneficiary_country = beneficiary_country;
    this.beneficiary_phone = beneficiary_phone;
    this.beneficiary_account_no = beneficiary_account_no;
    this.editId = Id; //for edit
    this.authService.GetbanktransferBeneficiaryDetailsbyId(Id).subscribe(response => {
      ;
      ////////console.log(response[0]);
      this.openBeneficiaryDialog(response[0]);

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }


  openBeneficiaryDialog(post: any) {
    post.editId = this.editId; //for edit
    this.submitted = true;
    const dialogRef = this.dialog.open(ConfirmbanktransferDialogComponent, {
      width: '550px',
      disableClose: true,
      hasBackdrop: true, // or false, depending on what you want
      autoFocus: false,
      maxHeight: '90vh', //you can adjust the value as per your view
      data: post
    });

    dialogRef.afterClosed().subscribe(result => {

    });


  }

  filterBeneficiary() {

    if (this.BeneficiaryFilterCtrl.value) {

      return this.BeneficiaryInfoList.filter((x: { text: string; }) => x.text.toLowerCase().indexOf(this.BeneficiaryFilterCtrl.value.toLowerCase()) > -1);
    } else {
      return this.BeneficiaryInfoList;
    }
  }


}


//  userorderdetailList: any;
//  stringJson: any;
//  stringObject: any;
//  submitted = false;
//  countryCode: any;
//  channelList: any;
//  balance: any;
//  ServiceName: any;
//  bankName: any;
//  finalAmount: any;
//  commissionFee: any;
//  commissionTotal: any;
//  amt: any;
//  data: any;
//  commissionList: any;
//  countryname: any;
//  recentReceiver: any;

//  KorapaybanktransfernigeriaForm: FormGroup;
//  maxDate = new Date();
//  currentUser: any;
//  token: any;
//  OptionList: any;
//  UsertBal: any;
//  serviceCode: any;
//  countryIsdcode: any;
//  ActualAmount: any;

//  public BankListFilterCtrl: FormControl = new FormControl();
//  protected _onDestroy1 = new Subject<void>();

//  BankList: any;

//  loadingspinner: boolean = false;

//  constructor(private authService: AuthService, private router: Router,
//    private route: ActivatedRoute, public dialog: MatDialog,
//    private fb: FormBuilder,
//    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {
//    this.countryIsdcode = localStorage.getItem('countryIsdcode');
//    //AccountCode == channel selected code
//    //channel == channel selected name
//    this.KorapaybanktransfernigeriaForm = this.fb.group({

//      PaymentModeCode: ["RRP"],
//      Password: [null],
//      Amount: [null, [Validators.required]],
//      account_number: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(20), Validators.minLength(3)]],
//      account_bank: [null, [Validators.required]],
//      email: [null, [Validators.required, Validators.email]],
//      name: [null, [Validators.pattern("^[a-zA-Z ]*$")]]

//    })
//  }


//  ngOnInit(): void {


//    this.token = this.tokenStorageService.getToken();
//    this.serviceCode = this.route.snapshot.queryParams.serviceCode;
//    if (this.token) {
//      this.currentUser = this.tokenStorageService.getUser();
//      this.UsertBal = this.tokenStorageService.getUsertBal();
//      this.getBanklist();
//      this.getcountryList();

//      // listen for search field value changes
//      this.BankListFilterCtrl.valueChanges
//        .pipe(takeUntil(this._onDestroy1))
//        .subscribe(() => {
//          this.filterBankList();
//        });
//    }
//    else {
//      this._service.callMethodOfSecondComponent();
//    }


//    this.f.Amount.valueChanges.subscribe(val => {
//      if (val == "") {
//        this.commissionFee = 0;
//        this.commissionTotal = 0;
//        this.ActualAmount = 0;
//      }
//      debugger
//      if (val && val.length > 0) {

//        if (this.f.PaymentModeCode.value && this.serviceCode) {
//          this.getServiceCommissionList(this.f.Amount.value, this.f.PaymentModeCode.value, this.serviceCode);
//        }
//        else {
//          this.toastr.error("Selected Proper Option", 'Error');
//        }
//        // Amount= ; AddService_Code=; PayService_Code= 
//      }
//    });
//  }

//  Back() {

//    this.router.navigate(['/Go-on']);
//  }

//  get f() { return this.KorapaybanktransfernigeriaForm.controls; }


//  getcountryList() {
//    this.submitted = false;

//    this.authService.getchannelList(this.serviceCode, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
//      ;
//      if (response.apiStatus == true) {
//        this.OptionList = response.apiData;

//      }
//      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
//        this.toastr.warning(response.apiMessage, 'Warning');
//        this._service.callMethodOfSecondComponent();
//      }
//      else {
//        this.toastr.error(response.apiMessage, 'Error');
//      }

//    }, (err: any) => {
//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {

//        this.toastr.error(err.error, 'Error');
//      }
//    }
//    );
//  }
//  string1: any;


//  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {

//    //this.submitted = true;
//    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
//    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, this.currentUser.serviceid).subscribe((response:
//      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {
//      if (response.apiStatus == true) {

//        this.commissionList = response.apiData;
//        this.amt = Amountrequested;
//        this.commissionFee = this.commissionList.totalCommission;
//        this.commissionTotal = this.commissionList.totalAmount;
//        this.ActualAmount = this.commissionList.actualAmount;

//        ////////console.log(this.commissionList);
//        ////////console.log(this.commissionFee);
//        ////////console.log(this.commissionTotal);

//        // this.toastr.successToastr(response.Message, AppConstant.success);
//      } else {
//        this.toastr.error(response.apiMessage, 'Error');
//      }

//    }, (err: any) => {
//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {

//        this.toastr.error(err.error, 'Error');
//      }
//    }
//    );
//  }






//  openPaymentConfirmDialog(data: any) {
//    const dialogRef = this.dialog.open(PaymentConfirmDialogComponent, {
//      width: '350px',
//      data: data
//    });

//    dialogRef.afterClosed().subscribe(result => {
//      window.location.reload();
//    });

//  }

//  getBanklist() {
//    ;

//    this.authService.GetkorapaybanklistDetails().subscribe(response => {

//      this.BankList = response.apiData;


//    }, (err: any) => {
//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {
//        this.toastr.error(err.error, 'Error');
//      }
//    }
//    );
//    //this.viewTransactions(codeval);
//  }

//  getBankname(bankNameval: any) {


//    this.bankName = bankNameval;
//    this.f.account_number.setValue(null);
//    this.f.Amount.setValue(null);
//    this.f.email.setValue(null);
//    this.f.name.setValue(null);
//    this.commissionFee = 0;
//    this.commissionTotal = 0;
//    this.ActualAmount = 0;
//    this.amt = 0;

//  }


//  openDialog(post: any) {

//    this.submitted = true;
//    if (this.KorapaybanktransfernigeriaForm.valid) {
//      post.serviceName = 'Korapay Nigeria Bank Transfer';
//      post.commissionFee = this.commissionFee;
//      post.OperatorName = this.bankName;
//      post.beneficiary_country = 'Nigeria';
//      post.beneficiary_account_no = post.account_number;
//      const dialogRef = this.dialog.open(BeforePaymentConfirmDialogComponent, {
//        width: '450px',
//        disableClose: true,
//        hasBackdrop: true, // or false, depending on what you want
//        autoFocus: false,
//        maxHeight: '90vh', //you can adjust the value as per your view
//        data: post
//      });

//      dialogRef.afterClosed().subscribe(result => {
//        ;
//        if (result !== undefined && result !== null && result) {

//          this.Korapaybanktransfernigeria(post);
//        }
//      });

//    }
//  }

//  Korapaybanktransfernigeria(post: any) {
//    //
//    this.submitted = true;
//    if (this.KorapaybanktransfernigeriaForm.valid) {
//      this.loadingspinner = true;
//      var PayServicsReq = null;
//      var AddServicsReq = null;

//      //pop up 
//      AddServicsReq = {
//        Amount: parseFloat(post.Amount), AccountCode: post.PaymentModeCode
//      }
//      //form 
//      PayServicsReq = {
//        Amount: parseFloat(post.Amount), account_bank: post.account_bank, AccountCode: this.serviceCode,
//        name: post.name, email: post.email, account_number: post.account_number

//      }

//      //
//      var post1 = {
//        //form
//        PayServicsReq: JSON.stringify(PayServicsReq),
//        //popup
//        AddServicsReq: JSON.stringify(AddServicsReq),
//        ServiceCode: this.serviceCode,
//        PaymentModeCode: post.PaymentModeCode,
//        DeviceType: "web"

//      }

//      this.stringJson = JSON.stringify(post1);
//      //console.log("String json object :", this.stringJson);

//      //  // ConvertjSON to an object
//      //  this.stringObject = JSON.parse(this.stringJson);
//      //  ////////console.log("JSON object -", this.stringObject);

//      this.authService.payTransferTokorapaybank(this.stringJson, this.currentUser.serviceid).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {

//        this.loadingspinner = false;
//        //console.log("data succ response -", response);

//        //{
//        //  "status": true, "message": "Transfer initiated successfully.", "data": {
//        //    "amount": "1000.00", "fee": "30.00", "currency": "NGN",
//        //      "status": "processing", "reference": "EZZUSD02099", "message": "Payout processing",
//        //        "customer": { "name": "rohit", "email": "rka89.sharma@gmail.com" }
//        //  }
//        //}


//        if (response.apiStatus == true && response.apiData.transactionStatus == 4) {
//          this.data = response.apiData;
//          this.KorapaybanktransfernigeriaForm.reset();
//          this.submitted = false;
//          this.commissionFee = 0;
//          this.commissionTotal = 0;
//          this.ActualAmount = 0;
//          this.openPaymentConfirmDialog(this.data);

//          this.tokenService.updateMessagetoken('token'); //after payment succeful done then update userinfo& bal          
//        }
//        else {
//          this.toastr.error(response.apiMessage, 'Error');
//          this.KorapaybanktransfernigeriaForm.reset();
//          this.submitted = false;
//          this.commissionFee = 0;
//          this.commissionTotal = 0;
//          this.ActualAmount = 0;
//        }

//        //var transactionStatus = this.data.status === 0 ? 'Pending' : this.data.status === 1 ? 'Proccessing' : this.data.status === 2 ? 'Success' : this.data.status === 3 ? 'Failed' : this.data.status === 4 ? 'In-process' : 'none'



//      }, (err: any) => {
//        this.loadingspinner = false;
//        if (err.error instanceof Error) {

//          this.toastr.error(err.error, 'Error');
//        } else {

//          this.toastr.error(err.error, 'Error');
//        }
//      }
//      );
//    }
//  }



//  viewTransactions(val: any) {

//    this.authService.getUserOrdersdetails1(val, this.currentUser.serviceid).subscribe(response => {
//      if (response.apiStatus == true) {
//        this.userorderdetailList = response.apiData;
//      } else {
//        this.toastr.error(response.apiMessage, 'Error');
//      }
//    }, (err: any) => {
//      if (err.error instanceof Error) {
//        this.toastr.error(err.error, 'Error');
//      } else {
//        this.toastr.error(err.error, 'Error');
//      }
//    }
//    );

//  }


//  filterBankList() {

//    if (this.BankListFilterCtrl.value) {

//      return this.BankList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.BankListFilterCtrl.value.toLowerCase()));
//    } else {
//      return this.BankList;
//    }
//  }

//}
